// Type-only module shared by AppInstallService, the pure resolver, and
// downstream consumers (Settings page, startup nudge, cs-app-install-sheet).
// Kept free of Angular / Capacitor / browser imports so tests under
// ts-node mocha can pull it in.

export enum InstallTargetKind {
  NativeStore = 'native-store',
  NativeOpen = 'native-open',
  PwaPrompt = 'pwa-prompt',
  None = 'none',
}

export type InstallPlatform = 'ios' | 'android' | 'desktop';

export type InstallTarget =
  | {
      kind: InstallTargetKind.NativeStore;
      storeUrl: string;
      // Optional on purpose (#5660): Android supplies it, iOS does not, and
      // the sheet renders the link only when it is present. Why:
      // design-docs/install-affordances.md, "Why iOS has no Open-in-app link".
      openUrl?: string;
      platform: 'ios' | 'android';
    }
  | { kind: InstallTargetKind.NativeOpen; openUrl: string; platform: 'android' }
  | { kind: InstallTargetKind.PwaPrompt }
  | { kind: InstallTargetKind.None };
